import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BackofficeLoginRequest, BackofficeLoginResponse } from './backoffice-auth-api.types';

@Injectable({ providedIn: 'root' })
export class BackofficeAuthApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = environment.apiBaseUrl;

  login(payload: BackofficeLoginRequest): Observable<BackofficeLoginResponse> {
    return this.http.post<BackofficeLoginResponse>(`${this.apiBaseUrl}/api/backoffice/login`, payload);
  }
}
